import { atomWithStorage } from "jotai/utils";

import { secureStorage } from "@/storage";

import type { UserMenu } from "../dtos/get-profile-data-response-dto";
import type { AuthUser } from "../types";

export const accessTokenAtom = atomWithStorage<string | null>(
  "_auth",
  null,
  {
    async getItem(key, initialValue) {
      try {
        const accessToken = await secureStorage.get<string>(key);
        return accessToken || initialValue;
      } catch {
        throw new Error("Not authenticated");
      }
    },

    async setItem(key, update) {
      try {
        if (update === null) {
          secureStorage.remove(key);
        } else {
          await secureStorage.set(key, update);
        }
      } catch {
        throw new Error("Error saving access token");
      }
    },

    async removeItem(key) {
      secureStorage.remove(key);
    }
  },
  {
    getOnInit: true
  }
);

export const userDataAtom = atomWithStorage<AuthUser | null>(
  "_user",
  null,
  {
    async getItem(key, initialValue) {
      try {
        const userData = await secureStorage.get<AuthUser | null>(key);
        return userData || initialValue;
      } catch {
        throw new Error("No user data");
      }
    },

    async setItem(key, update) {
      try {
        if (update === null) {
          secureStorage.remove(key);
        } else {
          await secureStorage.set(key, update);
        }
      } catch {
        throw new Error("Error saving user data");
      }
    },

    async removeItem(key) {
      secureStorage.remove(key);
    }
  },
  {
    getOnInit: true
  }
);

export const userMenuAtom = atomWithStorage<UserMenu[] | null>(
  "_menus",
  null,
  {
    async getItem(key, initialValue) {
      try {
        const userData = await secureStorage.get<UserMenu[] | null>(key);
        return userData || initialValue;
      } catch {
        throw new Error("No user menus");
      }
    },

    async setItem(key, update) {
      try {
        if (update === null) {
          secureStorage.remove(key);
        } else {
          await secureStorage.set(key, update);
        }
      } catch {
        throw new Error("Error saving user menus");
      }
    },

    async removeItem(key) {
      secureStorage.remove(key);
    }
  },
  {
    getOnInit: true
  }
);
